<template>
  <div class="concept-tag-selector">
    <div class="tags-container">
      <div class="title" v-if="concepts && concepts.length">
        {{ title || "Selected concepts:" }}
      </div>
      <div class="tags-wrapper">
        <concept-tag
          v-for="c in concepts"
          :color="highlighted && highlighted[c.id] ? 'black' : 'white'"
          :key="c.id"
          :data="c"
          @click="() => toggleConcept(c)"
          @remove="() => removeConcept(c)"
        />
        <div
          class="remove-btn"
          v-if="concepts.length > 0"
          @click="$emit('change', [])"
        >
          <div class="icon" />
        </div>
      </div>
    </div>
    <div class="reco-btn" @click="onShowPerfumes">
      <div class="text">{{ t("view_perfumes") }}</div>
    </div>
  </div>
</template>

<script>
import ConceptTag from "@/components/ConceptTag";
export default {
  components: { ConceptTag },
  props: {
    concepts: {
      type: Array,
    },
    highlighted: {
      type: Object,
      default: () => {},
    },
    title: {
      type: String,
    },
  },
  methods: {
    removeConcept(c) {
      this.$emit(
        "change",
        this.concepts.filter((cc) => cc.id !== c.id)
      );
    },
    toggleConcept(c) {
      let newHighlight = { ...this.highlighted };
      newHighlight[c.id] = !newHighlight[c.id];
      this.$emit("highlight", newHighlight);
    },
    onShowPerfumes() {
      let some = Object.values(this.highlighted).some((v) => v) > 0;
      let all = this.concepts.reduce((dict, c) => {
        dict[c.id] = true;
        return dict;
      }, {});
      if (some) this.$emit("show-recos", this.highlighted);
      else this.$emit("show-recos", all);
    },
  },
  model: {
    prop: "concepts",
    event: "change",
  },
};
</script>

<style lang="stylus" scoped>
.concept-tag-selector
  display: flex
  pointer-events: none

  .tags-container
    align-items: center
    background-color: #fff
    border: 1px solid $golden
    border-radius: 2px
    display: flex
    gap: vw(30px)
    padding: vw(10px)
    padding-left: vw(20px)
    pointer-events: all

    .mobile &
      background: none
      border: none
      left: 50%
      margin: none
      padding: none
      position: absolute
      top: vh(0)
      transform: translate(-50%, 0)

    .title
      m-font-size(18, 28)
      white-space: nowrap

      .mobile &
        display: none

  .tags-wrapper
    align-items: center
    display: flex
    gap: vw(10px)

    .mobile &
      flex-wrap: wrap
      justify-content: center
      width: 80vw

  .concept-tag
    cursor: pointer
    white-space: nowrap

  .remove-btn
    align-items: center
    border: 1px solid $golden
    border-radius: 50%
    cursor: pointer
    display: flex
    height: vw(35px)
    width: vw(35px)

    .icon
      m-icon("close", 18)
      flex: 1 1 0%

  .reco-btn
    m-font-size(14, 22)
    m-letter-spacing(20)
    align-items: center
    background-color: #000
    border-radius: 2px
    color: #fff
    cursor: pointer
    display: flex
    font-weight: 600
    padding: vw(16px) vw(28px)
    pointer-events: all
    white-space: nowrap

    .mobile &
      bottom: vh(150px)
      left: 50%
      margin: 0
      position: absolute
      transform: translate(-50%, 0)
</style>